import React from 'react';
import GoogleLogin from 'react-google-login';
import TwitterLogin from 'react-twitter-auth';
import { FacebookProvider, Login } from 'react-facebook';
import AppleSignin from 'react-apple-signin-auth';

import { authAPI } from '@mirinae/react-auth';
import { SNSButton } from '@mirinae/react-ui';

import { ButtonGroup } from '@mirinae/explorer/components/userauth/AuthPopupLayer';

import { explorerPaths, } from '@mirinae/shared/defines/paths';
import { FACEBOOK_APPID, GOOGLE_CLIENTID } from '@mirinae/shared/defines/keys';
import GTM from '@mirinae/shared/apis/GoogleAnalytics';
import { Event } from '@mirinae/explorer/modules/apis/GA3';

const GOOGLE_ENABLED = true;
const FACEBOOK_ENABLED = true;
const TWITTER_ENABLED = true;
const APPLE_ENABLED = true;

const SnsButtonsGroupContainer = (props) => {
    const { formData, isApp, onFailure } = props;
    const appleRedirectURI = `https://${window.location.host}/api/auth/check/apple`;

    return (
        <ButtonGroup>
            { GOOGLE_ENABLED && (
                <GoogleLogin
                    clientId={GOOGLE_CLIENTID}
                    render={({ onClick, disabled }) => (
                        <SNSButton theme="google" onClick={() => {
                            console.log('google SNS button clicked');
                            onClick();
                        }} disabled={disabled} />
                    )}
                    onSuccess={async (data) => {
                        // check for redirects
                        console.log('google login.onSuccess', data);
                        const qparams = new URLSearchParams(window.location.search);
                        const redirect = qparams.get('redirect');  // change of domain URL, disable loginSucceeded within-domain redirect & do it ourselves
                        await authAPI.responseGoogle(data, formData?.remember, explorerPaths.home, !redirect && props.loginCallbak, onFailure);
                        // if (props.loginCallbak) props.loginCallbak();
                        if (redirect) {
                            console.log('redirect from google login', redirect);
                            window.location.href = redirect;
                        }
                        Event('Login', 'google', isApp ? 'app' : 'web');
                    }}
                    onFailure={(error) => authAPI.handleAuthenticationError(error)}
                    cookiePolicy="single_host_origin"
                />
            )}
            { FACEBOOK_ENABLED && (
                <FacebookProvider appId={FACEBOOK_APPID}>
                    <Login
                        scope="email"
                        onCompleted={async (data) => {
                            const qparams = new URLSearchParams(window.location.search);
                            const redirect = qparams.get('redirect');  // change of domain URL, disable loginSucceeded within-domain redirect & do it ourselves
                            await authAPI.responseFacebook(data, formData.remember, explorerPaths.home, !redirect && props.loginCallbak, onFailure);
                            // if (props.loginCallbak) props.loginCallbak();
                            if (redirect) {
                                window.location.href = redirect;
                            }
                            Event('Login', 'facebook', isApp ? 'app' : 'web');
                        }}
                        onError={(error) => authAPI.handleAuthenticationError(error)}
                    >
                        {({ handleClick }) => ( // {({ loading, handleClick, error, data }) => (
                            <SNSButton theme="facebook" onClick={handleClick} />
                        )}
                    </Login>
                </FacebookProvider>
            )}

            { TWITTER_ENABLED && (
                <TwitterLogin
                    tag="div"
                    loginUrl={`https://${window.location.host}/api/auth/login/twitter`}
                    requestTokenUrl={`https://${window.location.host}/api/auth/token/twitter`}
                    onFailure={(error) => authAPI.handleAuthenticationError(error)}
                    onSuccess={(response) => {
                        console.log('TwitterLogin onSucces', response);
                        response.json().then(async body => {
                            const qparams = new URLSearchParams(window.location.search);
                            const redirect = qparams.get('redirect');  // change of domain URL, disable loginSucceeded within-domain redirect & do it ourselves
                            await authAPI.responseTwitter(JSON.stringify(body).split('response:')[0], formData.remember, explorerPaths.home, !redirect && props.loginCallbak, onFailure);
                            if (redirect) {
                                window.location.href = redirect;
                            }
                        });
                        GTM.userAction('login', { type: 'twitter' }, 'explorer');
                        Event('Login', 'twitter', isApp ? 'app' : 'web');
                    }}
                >
                    <SNSButton theme="twitter" onClick={() => {}} />
                </TwitterLogin>
            )}

            { APPLE_ENABLED && (
                <AppleSignin
                    authOptions={{
                        clientId: 'mobile.mirinae.com',
                        scope: 'name email',
                        redirectURI: appleRedirectURI,
                        /** Nonce */
                        nonce: 'nonce',
                        usePopup: true,
                    }} // REQUIRED
                    noDefaultStyle={false}
                    onSuccess={async (response) => {
                        console.log('AppleSignin onSucces', response);
                        const { authorization } = response;
                        const qparams = new URLSearchParams(window.location.search);
                        const redirect = qparams.get('redirect');  // change of domain URL, disable loginSucceeded within-domain redirect & do it ourselves
                        await authAPI.responseApple(authorization, formData.remember, explorerPaths.home, !redirect && props.loginCallbak, onFailure);
                        if (redirect) {
                            window.location.href = redirect;
                        }
                        Event('Login', 'apple', isApp ? 'app' : 'web');
                    }}
                    onError={(error) => {
                        console.error('AppleSignin onError', error);
                        window.location.replace('/');
                    }}
                    render={(props) => <SNSButton theme="apple" {...props} />}
                />
            )}
        </ButtonGroup>
    );
};


export default SnsButtonsGroupContainer;